<script setup>
import { computed } from "vue";
import { cn } from "@/lib/utils";
import badgeVariants from "./variants";

const props = defineProps({
  variant: {
    type: String,
    default: "default",
  },
});

const VALID_VARIANTS = new Set([
  "primary",
  "danger",
  "success",
  "info",
  "warning",
  "muted",
  "outline-primary",
  "outline-danger",
  "outline-success",
  "outline-info",
  "outline-warning",
  "outline-muted",
  "ghost",
]);

const safeVariant = computed(() => {
  return VALID_VARIANTS.has(props.variant) ? props.variant : "muted";
});
</script>

<template>
  <div :class="cn(badgeVariants({ variant: safeVariant }), $attrs.class ?? '')">
    <slot />
  </div>
</template>
